import moment       from 'moment';
import { dmpSexes } from '../../constants/dmpConstants';

export const getSexFromIns = (nir) => {
  const firstDigit = nir.charAt(0);
  
  switch (Number(firstDigit)) {
    case 1:
    case 3:
    case 7:
      return dmpSexes.MALE;
    case 2:
    case 4:
    case 8:
      return dmpSexes.FEMALE;
    default:
      return dmpSexes.UNKNOWN;
  }
};

export const extractPatientInfoFromIdentity = (identity = {}) => {
  const {
          Identity: {
            s_birthName  = '',
            s_birthGiven = '',
            s_birthDate  = '',
            i_sex        = '',
          } = {},
        } = identity;
  
  const [given] = s_birthGiven.split(' ');
  
  return {
    name     : '',
    givenName: given,
    birthday : moment(s_birthDate, 'YYYY-MM-DD').format('YYYYMMDD'),
    birthName: s_birthName || '',
    sex      : i_sex,
  };
};